import { useEffect } from 'react';
import { Text } from '@fluentui/react-components';

export default function SettingsPayments() {
  useEffect(() => {
    window.dispatchEvent(new CustomEvent('setPageContext', {
      detail: { title: 'Payment providers' },
    }));
    return () => {
      window.dispatchEvent(new CustomEvent('setPageContext', { detail: null }));
    };
  }, []);

  return (
    <div style={{ padding: '1rem' }}>
      <Text>Configure your payment provider settings here.</Text>
    </div>
  );
}
